// Question names where multiple `type` values are runtime-compatible.
// Used in two places that must stay in lock-step:
// - `getQuestionsWithConflict` — cross-workflow type conflict detection.
// - `matchesTemplateConfig` (editor template validation) — accept either shape
//   for pre-existing forms when `allowEquivalentTypes` is opted in.
//
// `assessmentRespondent` supports `assignees` (legacy) and `supplierPortalAssignees`
// (current canonical) indefinitely. The Create Assessment backend accepts either
// answer shape.
export const QUESTION_TYPE_EQUIVALENCES: Record<string, ReadonlySet<string>> = {
  assessmentRespondent: new Set(['assignees', 'supplierPortalAssignees']),
}
